import { IssuanceDocumentType } from 'constants/IssuanceDocument';
import { Description, labelColor, labelSize } from 'views/mutual/description';

export const IssuanceDocumentNote = ({ folderId }: { folderId: string }) => {
  const folderType = folderId.slice(0, 2);
  switch (folderType) {
    case IssuanceDocumentType.LeaseFund:
      return (
        <Description
          labelColor={labelColor.gray}
          labelSize={labelSize.small}
          label="※仕訳例は、格納までに少々お時間をいただいております。格納されない場合は、時間をおいてから再度ご確認ください。"
        />
      );
  }
  return <></>;
};
